import axios, { AxiosStatusCode } from '../axios';
import * as phone from '../phone';
import * as uploads from '../uploads';
import { UUID } from '../uuid';
import { GetPageRequestID } from './pagerequests';

declare interface myWindow extends Window {
    readonly pageRequestID: string;
    readonly reCaptchaV2SiteKey: string;
    readonly reCaptchaSiteKey: string;
}
declare const window: myWindow;

export interface CreateContactOpts {
    $reCaptchaPlaceholder: HTMLElement;
    name: string;
    company: string;
    phone: phone.Phone;
    email: string;
    content: string;
    uploader?: uploads.Uploader;
    preferSMS?: boolean;
    ignoreSMSPreference?: boolean;
}

export const ReCaptchaError = new Error('Please complete the reCAPTCHA and try again.');

export async function CreateContact(opts: CreateContactOpts) {
    const data: Record<string, unknown> = { // TODO: this should just be a declared interface
        'name': opts.name,
        'company': opts.company,
        'phone': await opts.phone.Format(),
        'email': opts.email,
        'preferSMS': opts.preferSMS,
        'ignoreSMSPreference': opts.ignoreSMSPreference,
        'content': opts.content,
        'referrer': location.href,
        'pageRequestID': await GetPageRequestID(),
        'tz': new Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    if (opts.uploader) {
        data['uploadIDs'] = opts.uploader.GetUploadIDs();
    }

    return new Promise((resolve, reject) => {
        const createContact = () => axios.post('/contacts', data);

        const v2 = Boolean(opts.$reCaptchaPlaceholder.innerHTML);

        if (!opts.$reCaptchaPlaceholder.id) {
            opts.$reCaptchaPlaceholder.id = `recaptcha-${UUID()}`;
        }

        if (v2) {
            const reCaptchaRenderID = parseInt(opts.$reCaptchaPlaceholder.getAttribute('data-widget-id') ?? '0', 10);
            const response = grecaptcha.getResponse(reCaptchaRenderID);
            if (!response) {
                return reject(ReCaptchaError);
            }

            data['recaptcha'] = response;
            data['recaptchaVersion'] = 2;

            createContact().
                then(resolve).
                catch(err => {
                    grecaptcha.reset(reCaptchaRenderID);

                    reject(err);
                });
        } else {
            grecaptcha.ready(async () => {
                try {
                    const token = await grecaptcha.execute(window.reCaptchaSiteKey, { 'action': 'contact' });

                    data['recaptcha'] = token;

                    const resp = await createContact();
                    if (AxiosStatusCode(resp) === 200) {
                        const reCaptchaRenderID = grecaptcha.render(opts.$reCaptchaPlaceholder.id, {
                            'sitekey': window.reCaptchaV2SiteKey,
                        });
                        opts.$reCaptchaPlaceholder.setAttribute('data-widget-id', String(reCaptchaRenderID));

                        reject(ReCaptchaError);
                        return;
                    }

                    resolve(resp);
                } catch (err) {
                    reject(err);
                }
            });
        }
    });
}